import { useNavigate } from 'react-router-dom';
import { BlogPost } from '@/types/blog';

interface PostCardProps {
  post: BlogPost;
}

export default function PostCard({ post }: PostCardProps) {
  const navigate = useNavigate();

  return (
    <article className="bg-white border border-[#E9D59C]/40 rounded-lg overflow-hidden hover:-translate-y-1 transition-transform duration-300 flex flex-col">
      {post.imagem_url && (
        <div className="w-full h-44 overflow-hidden">
          <img
            src={post.imagem_url}
            alt={post.titulo}
            className="w-full h-full object-cover object-top"
          />
        </div>
      )}
      <div className="bg-[#0A1829] px-6 py-4 flex items-center justify-between">
        <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.15em] uppercase">{post.categoria}</span>
        <span className="text-white/35 text-xs font-sans">{post.tempo_leitura}</span>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="text-[#0A1829]/40 text-xs font-sans mb-3">
          {new Date(post.data_publicacao).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
        </div>
        <h2 className="font-serif text-xl text-[#0A1829] font-medium leading-snug mb-3 hover:text-[#B39B62] transition-colors">
          <a href={`/blog/${post.slug}`} onClick={(e) => { e.preventDefault(); navigate(`/blog/${post.slug}`); }} className="cursor-pointer">
            {post.titulo}
          </a>
        </h2>
        <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed flex-1 mb-5">{post.resumo}</p>
        <a
          href={`/blog/${post.slug}`}
          onClick={(e) => { e.preventDefault(); navigate(`/blog/${post.slug}`); }}
          className="inline-flex items-center gap-2 text-[#B39B62] font-sans font-semibold text-xs hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap self-start border border-[#B39B62]/40 hover:border-[#B39B62] hover:bg-[#B39B62]/5 px-4 py-2 rounded-md"
        >
          Ler mais <i className="ri-arrow-right-line text-xs"></i>
        </a>
      </div>
    </article>
  );
}
